/*
 * Sentry 初期化 (TVB-182 / TVB-184)
 * snippets/sentry-head.liquid から sentry.min.js の直後に defer で読み込まれる。
 * 前提: window.__sentryConfig / window.__sentryEarlyQueue が同 snippet のインラインスクリプトで定義済み。
 * 監視自体がストアの動作を壊さないよう、全体を try/catch で無害化する。
 */
(function () {
  // 同一 URL のリソース読み込み失敗は 1 ページビューにつき 1 回だけ送信する
  var reportedResources = {};
  // CDN 全断ユーザー(中国圏・広告ブロッカー等)が数十イベントを一斉送信しないための上限
  var MAX_RESOURCE_REPORTS = 5;
  var resourceReportCount = 0;

  // 自テーマで制御できないサードパーティ由来 URL のパターン (2リスト構成)。
  // DENY_URL_PATTERNS は denyUrls 用 = イベント発生元スクリプト (最内フレーム) の除外。
  // fetch/XHR をラップするスクリプト (Global-e / Web Pixels Manager 等) をここに
  // 入れると、テーマ発の fetch 失敗イベントまで最内フレーム判定で破棄されるため
  // 入れないこと (それらは beforeSend 側の FRAME_PATTERNS でのみ判定する)
  var DENY_URL_PATTERNS = [
    // 計測系サードパーティ (カート調査のノイズになるため除外)
    /statics\.a8\.net/,
    /clarity\.ms/,
    /dmp\.im-apps\.net/,
    /\/cdn\/shopifycloud\//, // Shopify 純正 shop-js 等 (店舗ドメインプロキシ形式)
    /cdn\.shopify\.com\/shopifycloud\//, // 同上 (cdn.shopify.com 直配信形式)
    /\/proxy\/[0-9a-f]{64}\//, // ScriptTag のプロキシ配信
    /^blob:/,
    /client\.discounthuntapp\.com/
  ];
  // beforeSend の全フレーム判定用。DENY に加えて fetch ラッパー系・アプリ埋め込みを含む
  var THIRD_PARTY_FRAME_PATTERNS = DENY_URL_PATTERNS.concat([
    /\/cdn\/wpm\//, // Shopify Web Pixels Manager (fetch をラップするため denyUrls 不可)
    /\/wpm@/, // 同上 (店舗ドメイン直下の /wpm@<hash>/ 形式)
    /\/web-pixels?(@|\/)/, // Web Pixels サンドボックス worker (web-pixel@ / web-pixels@ 両形式)
    // ホスト境界でアンカーする: ページ URL のクエリ等に 'global-e.com' を含む場合に、
    // テーマのインライン script (フレーム = ページ URL) を誤って第三者判定しないため
    /^(https?:)?\/\/([a-z0-9-]+\.)*global-e\.com\//, // web. / crossborder-integration. 等 (fetch ラッパー)
    /^(https?:)?\/\/cdn\.langshop\.app\//, // LangShop 翻訳アプリ (fetch をラップするため denyUrls 不可)
    // Klaviyo onsite トラッキング (fender_analytics 等) の配信パス。localStorage 満杯の
    // クライアントで QuotaExceededError を throw する (VIVION-BLUE-XY/Y1/Y2)。
    // テーマ資産は /cdn/shop/t/N/assets/、インライン script のフレームはページ URL のため誤判定しない
    /\/onsite\/js\//,
    /cdn\.shopify\.com\/extensions\//, // アプリ埋め込み (直配信)
    /\/extensions\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\//, // 同 (店舗ドメインプロキシ形式)
    // Shopify 内部計測スクリプト (trekkie.storefront 等) の配信パス。旧ブラウザの
    // sendBeacon 制限等がスクリプト内で完結して throw する (VIVION-BLUE-12H)。
    // fetch/sendBeacon をラップする可能性があるため denyUrls ではなくこちらに置く
    /\/cdn\/s\//
  ]);

  // 「素のネットワーク失敗」イベント専用の追加フレームパターン (isThirdPartyNetworkNoise
  // でのみ使用)。usf.js はテーマアセットパスに置かれるアプリ生成物のため、汎用の
  // THIRD_PARTY_FRAME_PATTERNS に入れると USF 本体の将来バグ (構文エラー・検索無反応等の
  // 実害クラス) まで隠れてしまう。fetch の回線断ノイズに限定して第三者扱いする
  var NETWORK_NOISE_EXTRA_FRAME_PATTERNS = [
    /\/assets\/usf(-boot)?\.js/, // USF 検索アプリの生成物 (fetchkg 等が fetch を発行する)
    /\/resources\/js\/app\b/, // 実行時注入の fetch ラッパー (配信元不明。TVB-216 で汎用登録は見送り)
    // Shopify が注入する fetch ラッパー。/resources/js/app → /shopify/plugins/<uuid>.js →
    // /cdn/wpm/ → /cdn/shopifycloud/ と連なるスタックの途中に現れ、これだけがパターン漏れで
    // 「Load failed」が通知されていた (VIVION-BLUE-19Q/A7)。素のネットワーク失敗に限定する
    /\/shopify\/plugins\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.js/
  ];

  // WebKit の「Load failed」等、宛先ホスト情報を持たないネットワーク失敗の
  // unhandledrejection は、メッセージ除外するとテーマ発 fetch の失敗まで隠れるため
  // できない。「素のネットワーク失敗文言 (ホスト付きは対象外)」かつ「有効フレームが
  // 全て 既知サードパーティ + USF 系」の場合に限り破棄する (VIVION-BLUE-9Q/BW/XM/XJ 等)。
  // テーマのカート系 fetch は全経路が try/catch + 明示 captureException のため影響しない
  var BARE_NETWORK_FAILURE_RE = /^(Load failed|Failed to fetch|NetworkError when attempting to fetch resource\.)$/;
  function isThirdPartyNetworkNoise(event) {
    try {
      var exceptions = event.exception && event.exception.values;
      if (!exceptions || !exceptions.length) return false;
      var last = exceptions[exceptions.length - 1];
      if ((last.type || '') !== 'TypeError') return false;
      if (!BARE_NETWORK_FAILURE_RE.test(last.value || '')) return false;
      return isThirdPartyOnlyEvent(event, NETWORK_NOISE_EXTRA_FRAME_PATTERNS);
    } catch (e) {
      return false;
    }
  }

  // EasyPoints / Lunaris Loyalty がユーザーのブラウザのストレージブロック設定下で
  // sessionStorage にアクセスした際に投げる SecurityError。サードパーティ app の
  // ブラウザストレージ API 起因で theme 側で制御不可能なため、usf.js と同じ理由で
  // 専用の追加フレームパターンでのみ third-party 判定する(汎用登録すると該当ファイルの
  // 将来の実バグまで隠れてしまうため) (VIVION-BLUE-136/135/134)
  var STORAGE_NOISE_EXTRA_FRAME_PATTERNS = [
    /\/assets\/easy_points(_integration)?(\.min)?\.js/,
    /\/lunaris-loyalty-[^/]+\/assets\/sdk\.bundle\.js/
  ];
  var STORAGE_SECURITY_ERROR_RE = /^The operation is insecure\.$/;
  function isThirdPartyStorageNoise(event) {
    try {
      var exceptions = event.exception && event.exception.values;
      if (!exceptions || !exceptions.length) return false;
      var last = exceptions[exceptions.length - 1];
      if ((last.type || '') !== 'SecurityError') return false;
      if (!STORAGE_SECURITY_ERROR_RE.test(last.value || '')) return false;
      return (
        isThirdPartyOnlyEvent(event, STORAGE_NOISE_EXTRA_FRAME_PATTERNS) ||
        isInlineStorageNoise(exceptions)
      );
    } catch (e) {
      return false;
    }
  }

  // EasyPoints のインライン実装 (関数 createEasyPointsSession、フレーム URL はページ URL) や
  // GTM が挿入するスクリプト (/gtm.js) 経由の SecurityError は、フレームがページ URL になり
  // ファイル名ベースの判定に当たらない (VIVION-BLUE-1HD/1HB/1HA/17W)。
  // 「グローバル onerror 捕捉」かつ「テーマアセット (assetBase 配下) のフレームを含まない」かつ
  // 「上記の既知の発生元がスタックにある」場合に限って破棄する。テーマ自身の
  // ストレージアクセス失敗は assetBase フレームを含むため残る
  function isInlineStorageNoise(exceptions) {
    var last = exceptions[exceptions.length - 1];
    var mechanismType = (last.mechanism && last.mechanism.type) || '';
    if (mechanismType.indexOf('onerror') === -1) return false;
    var assetBase = config && config.assetBase;
    if (!assetBase) return false;
    var sawKnownCulprit = false;
    for (var i = 0; i < exceptions.length; i++) {
      var frames = exceptions[i].stacktrace && exceptions[i].stacktrace.frames;
      if (!frames) continue;
      for (var j = 0; j < frames.length; j++) {
        var filename = frames[j].filename || '';
        if (filename.indexOf(assetBase) !== -1) return false;
        if (frames[j].function === 'createEasyPointsSession' || /\/gtm\.js(\?|$)/.test(filename)) {
          sawKnownCulprit = true;
        }
      }
    }
    return sawKnownCulprit;
  }

  // 非 Error オブジェクトがそのまま throw/reject された場合、SDK は
  // exception.value を "Object captured as promise rejection with keys: ..." /
  // "<コンストラクタ名>: Event `...` captured as promise rejection" のような
  // 汎用文言にし、元オブジェクトの中身は event.extra.__serialized__ に格納する
  // (ignoreErrors のメッセージ一致では特定できない)。ここでは __serialized__ の
  // 中身を見て、サードパーティ由来と断定できるものだけを狭い条件で破棄する
  function isSerializedThirdPartyNoise(event) {
    try {
      var serialized = event.extra && event.extra.__serialized__;
      if (!serialized || typeof serialized !== 'object') return false;
      // 広告SDKのreject形状({code, message})。code は当該広告SDK固有の数値で
      // 汎用オブジェクトとの衝突を避けるため message の文言も併せて確認する
      // (VIVION-BLUE-13M)
      if (
        serialized.code === 30005 &&
        typeof serialized.message === 'string' &&
        /Ad loaded,?\s*but response or ad data is empty/.test(serialized.message)
      ) {
        return true;
      }
      // XHR の ProgressEvent(type=error) が reject された場合、SDK は
      // event.target を含めてシリアライズする。宛先が Klaviyo API の場合のみ
      // 破棄する(ホスト情報が無い WebKit の「Load failed」と異なりここでは
      // 宛先ホストが明確なため、狭くピンポイントに判定できる) (VIVION-BLUE-13C)
      var targetUrl = serialized.target && serialized.target._url;
      if (typeof targetUrl === 'string' && /^https:\/\/a\.klaviyo\.com\//.test(targetUrl)) {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  // 旧ブラウザが Shopify 生成インライン module (top-level await 等) や外部スクリプトを
  // パースできず出す SyntaxError はテーマ側で対処できないノイズ (VIVION-BLUE-12F/12G)。
  // ただし以下は実バグの一級シグナルのため破棄しない:
  // - フレームにテーマアセット (assetBase 配下) を含む構文エラー = デプロイ事故
  // - メッセージに JSON を含むもの = JSON.parse の入力破損 (cookie 等)
  // - グローバル onerror 捕捉以外 (明示 capture・unhandledrejection)
  function isNonThemeSyntaxError(event) {
    try {
      var exceptions = event.exception && event.exception.values;
      if (!exceptions || !exceptions.length) return false;
      var last = exceptions[exceptions.length - 1];
      if ((last.type || '') !== 'SyntaxError') return false;
      if (String(last.value || '').indexOf('JSON') !== -1) return false;
      // パース時構文エラーは window.onerror 経由でのみ届く
      // (auto.browser.global_handlers.onerror)。onunhandledrejection は含めない
      var mechanismType = (last.mechanism && last.mechanism.type) || '';
      if (mechanismType.indexOf('onerror') === -1) return false;
      var assetBase = config && config.assetBase;
      if (!assetBase) return false;
      for (var i = 0; i < exceptions.length; i++) {
        var frames = exceptions[i].stacktrace && exceptions[i].stacktrace.frames;
        if (!frames) continue;
        for (var j = 0; j < frames.length; j++) {
          var filename = frames[j].filename || '';
          if (filename.indexOf(assetBase) !== -1) return false;
        }
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  // グローバル捕捉(onerror / onunhandledrejection / SDK 計装)のイベントで、
  // SDK 自身のフレームを除いた有効フレームが全て既知サードパーティに一致する場合のみ
  // true を返す。テーマのインライン script はフレーム URL がページ URL になるため
  // どのパターンにも一致せず送信される(フェイルオープン)。
  // extraPatterns は isThirdPartyNetworkNoise 専用の追加リスト (通常判定では使わない)
  function isThirdPartyOnlyEvent(event, extraPatterns) {
    try {
      var exceptions = event.exception && event.exception.values;
      if (!exceptions || !exceptions.length) return false;
      // linkedErrors は cause 連鎖の例外を values の先頭に prepend するため、
      // グローバル捕捉の mechanism は末尾の例外に付く
      var mechanism = exceptions[exceptions.length - 1].mechanism || {};
      var type = mechanism.type || '';
      // 同梱 SDK (10.63.0) が付ける mechanism は auto.* 系のみ。
      // onerror / onunhandledrejection / instrument は SDK 更新時の形式変化への保険
      var isGlobalCapture =
        type === 'onerror' ||
        type === 'onunhandledrejection' ||
        type.indexOf('instrument') === 0 ||
        type.indexOf('auto.') === 0;
      // テーマ計装からの明示 capture (cart-add-rejected 等) は対象外
      if (!isGlobalCapture) return false;
      var patterns = extraPatterns
        ? THIRD_PARTY_FRAME_PATTERNS.concat(extraPatterns)
        : THIRD_PARTY_FRAME_PATTERNS;
      var sawFrame = false;
      for (var i = 0; i < exceptions.length; i++) {
        var frames = exceptions[i].stacktrace && exceptions[i].stacktrace.frames;
        if (!frames) continue;
        for (var j = 0; j < frames.length; j++) {
          var filename = frames[j].filename || '';
          // SDK の fetch 計装ラッパーや native / 無名フレームは発生元の判定材料にしない
          if (
            !filename ||
            filename.indexOf('/sentry.min.js') !== -1 ||
            filename.indexOf('/sentry-init.js') !== -1 ||
            filename.indexOf('[native code]') !== -1 ||
            filename.indexOf('<anonymous>') !== -1
          ) {
            continue;
          }
          sawFrame = true;
          var isThirdParty = false;
          for (var k = 0; k < patterns.length; k++) {
            if (patterns[k].test(filename)) {
              isThirdParty = true;
              break;
            }
          }
          // テーマ資産・ページ由来のフレームが 1 つでもあれば送信する
          if (!isThirdParty) return false;
        }
      }
      // 有効フレームが 1 つも無いイベントは判定できないため送信する
      return sawFrame;
    } catch (e) {
      return false;
    }
  }

  function removeEarlyListeners() {
    if (window.__sentryOnEarlyError) {
      window.removeEventListener('error', window.__sentryOnEarlyError, true);
    }
    if (window.__sentryOnEarlyRejection) {
      window.removeEventListener('unhandledrejection', window.__sentryOnEarlyRejection);
    }
    window.__sentryEarlyQueue = [];
  }

  var config = window.__sentryConfig;
  var SentrySdk = window.Sentry;
  if (!config || !config.dsn || !SentrySdk || typeof SentrySdk.init !== 'function') {
    // SDK が読み込めない場合(広告ブロッカー・404 等)は、早期キューの
    // リスナーを解除してキューを破棄し、メモリを保持し続けない
    removeEarlyListeners();
    return;
  }

  try {
    var integrations = [];
    if (SentrySdk.captureConsoleIntegration) {
      // 既存コードの大半は fetch 失敗等を console.error で握りつぶしているため、
      // console.error をイベントとして送信して可視化する
      integrations.push(SentrySdk.captureConsoleIntegration({ levels: ['error'] }));
    }

    SentrySdk.init({
      dsn: config.dsn,
      environment: config.environment,
      sampleRate: config.sampleRate,
      integrations: integrations,
      ignoreErrors: [
        'AbortError',
        'Script error.',
        /ResizeObserver loop/,
        'Non-Error promise rejection captured',
        // Shopify 純正 WebMCP (storefront/src/registration) が Permissions-Policy に
        // ブロックされて出すノイズ。フレームが sourcemap 解決済みの相対パス
        // (../src/registration.ts) のため URL ベースのフレームパターンでは捕捉できない
        /Failed to execute 'registerTool' on 'ModelContext'/,
        // Shopify 純正 shop-js のテレメトリ送信先。広告ブロッカー等による fetch 失敗が
        // unhandledrejection になるノイズ (VIVION-BLUE-53)。このホストは Shopify の
        // 計測専用でテーマの fetch は到達しないため、メッセージ一致で安全に除外できる。
        // スタックが SDK フレームのみになりフレーム判定がフェイルオープンする変種への保険
        /otlp-http-production\.shopifysvc\.com/,
        // UpPromote (Secomapp) のトラッキングピクセル。広告ブロッカーによる fetch 失敗が
        // 実行時注入の未知 fetch ラッパー (/resources/js/app) 経由でフレーム判定を
        // すり抜けるため (VIVION-BLUE-V6/TR)、宛先ホストのメッセージ一致で除外する
        /pixel\.uppromote\.com/,
        // Shopify 純正 shop-js の cart-sync 動的 import 失敗。CDN/回線起因で検知フレームが
        // ページ URL のみになり isThirdPartyOnlyEvent 側では判定できないため、
        // OTLP テレメトリ(VIVION-BLUE-53)と同じ理由でメッセージ一致除外する (VIVION-BLUE-13P/13F)
        /shop-js\/modules\/v2\/loader\.init-shop-cart-sync/,
        // ブラウザ拡張機能(content script)がタブ間メッセージングに失敗した際のノイズ。
        // スタックトレースが無くページ URL のみのためフレーム判定では捕捉できない。
        // メッセージが拡張機能 API 特有の文言でテーマ発イベントとの衝突リスクが無いため
        // メッセージ一致で安全に除外できる (VIVION-BLUE-12R)
        /Invalid call to runtime\.sendMessage/,
        // Shopify Web Pixels のサンドボックス Worker が pixel スクリプトを読み込めない
        // 失敗 (VIVION-BLUE-15N。スタック無し、累計 22 万件超・5 ユーザーで枠を消費)。
        // 対象は Shopify 配信の /web-pixels/ のみでテーマの fetch/script は含まれない
        /Failed to execute 'importScripts' on 'WorkerGlobalScope'.*\/web-pixels\//,
        // 動画プレイヤー等の DRM (EME) 失敗。メッセージの系統コードが違うたびに別 issue に
        // なる (VIVION-BLUE-HJ/14H/1H8)。テーマは EME を使わないため全て第三者由来
        /MediaKeySession/
      ],
      denyUrls: DENY_URL_PATTERNS,
      // denyUrls は最内フレームの URL でのみ判定されるため、最内フレームが SDK の
      // 計装ラッパー (sentry.min.js) になるケースはすり抜ける。beforeSend で
      // 「有効フレームが全てサードパーティ」のイベントを破棄する
      beforeSend: function (event) {
        return isThirdPartyOnlyEvent(event) ||
          isThirdPartyNetworkNoise(event) ||
          isNonThemeSyntaxError(event) ||
          isThirdPartyStorageNoise(event) ||
          isSerializedThirdPartyNoise(event)
          ? null
          : event;
      }
    });

    if (config.tags) SentrySdk.setTags(config.tags);
    // ログイン済み顧客のみ数値IDを付与する(メールアドレス・氏名等は送らない)。
    // ゲストではnullのため呼ばない(TVB-241: 発生ユーザーを追跡し再現状況を確認するため)
    if (config.customerId) SentrySdk.setUser({ id: String(config.customerId) });

    // 計装コード(product-form.js 等)はこの参照だけを使う。
    // アプリ埋め込みが window.Sentry を定義・上書きしていても、テーマの
    // 診断データが第三者の Sentry に送信されないようにするための契約
    window.__themeSentry = SentrySdk;

    // SDK ロード前に発生したエラー(sentry-head.liquid のキュー)を再送する
    var queue = window.__sentryEarlyQueue || [];
    removeEarlyListeners();
    queue.forEach(function (item) {
      try {
        // 再送はグローバル捕捉の代行のため mechanism を明示し、beforeSend の
        // サードパーティ判定 (isThirdPartyOnlyEvent) の対象に含める。
        // 省略すると mechanism が generic/handled になり判定を素通りする
        if (item.type === 'unhandledrejection') {
          SentrySdk.captureException(item.event.reason || 'Unhandled rejection (early)', {
            mechanism: { type: 'auto.browser.global_handlers.onunhandledrejection', handled: false }
          });
        } else if (item.event.target && item.event.target !== window && item.event.target.tagName) {
          reportResourceError(item.event.target);
        } else {
          SentrySdk.captureException(item.event.error || item.event.message || 'Unknown early error', {
            mechanism: { type: 'auto.browser.global_handlers.onerror', handled: false }
          });
        }
      } catch (e) {
        /* 再送失敗は無視 */
      }
    });

    // テーマアセット(Shopify CDN)の読み込み失敗を捕捉する。
    // constants.js 等の読込失敗は「カートに追加を押しても無反応」の原因候補。
    window.addEventListener(
      'error',
      function (event) {
        var target = event.target;
        if (!target || target === window || !target.tagName) return;
        reportResourceError(target);
      },
      true
    );

    // /cart/add のサーバエラー(PUB_SUB_EVENTS.cartError)を捕捉する。
    // product-form 経由の全経路(商品ページ・quick-add・campaign-lp)をテーマ側の改修なしでカバーする。
    // 本ファイルは defer 文書順で pubsub.js より先に実行されるため、購読は DOMContentLoaded まで遅延する。
    document.addEventListener('DOMContentLoaded', function () {
      try {
        if (
          typeof subscribe !== 'function' ||
          typeof PUB_SUB_EVENTS === 'undefined' ||
          !PUB_SUB_EVENTS.cartError
        ) {
          return;
        }
        subscribe(PUB_SUB_EVENTS.cartError, function (data) {
          // publish() は subscriber の例外を捕捉しないため、ここで例外を漏らすと
          // product-form のエラー表示(handleErrorMessage)が実行されなくなる。必ず内側で握る
          try {
            data = data || {};
            var source = String(data.source || 'unknown');
            // Shopify の /cart/add.js は message が常に汎用の 'Cart Error' で、
            // 在庫切れ・購入制限などの実際の理由は errors(description)側に入る
            var detail = data.errors || data.message;
            if (detail && typeof detail !== 'string') {
              try {
                detail = JSON.stringify(detail);
              } catch (jsonError) {
                detail = String(detail);
              }
            }
            SentrySdk.withScope(function (scope) {
              scope.setTag('cart_flow', source);
              scope.setContext('cart_error', {
                source: data.source,
                productVariantId: data.productVariantId,
                detail: detail
              });
              scope.setFingerprint(['cart-add-rejected', source]);
              SentrySdk.captureMessage(
                'Cart add rejected (' + source + '): ' + (detail || 'no detail'),
                'warning'
              );
            });
          } catch (e) {
            /* 監視の失敗で既存挙動に影響を与えない */
          }
        });
      } catch (e) {
        /* 監視の失敗で既存挙動に影響を与えない */
      }
    });
  } catch (e) {
    // 初期化に失敗しても早期キューのリスナーは解除し、ストア動作に影響を与えない
    removeEarlyListeners();
  }

  function isAutomatedClient() {
    try {
      return (
        navigator.webdriver === true ||
        /HeadlessChrome|bot\b|crawl|spider|lighthouse|PhantomJS/i.test(navigator.userAgent || '')
      );
    } catch (e) {
      return false;
    }
  }

  function reportResourceError(target) {
    var url = target.src || target.href || '';
    var tagName = (target.tagName || '').toLowerCase();
    // 監視の目的は constants.js 等テーマ JS/CSS の読込失敗検知。アプリ拡張
    // (/extensions/)・プロキシ・コンテンツ画像 <img> は自テーマで制御できない
    // ノイズのため送らない。テーマアセットは vivionblue.com 配信のため
    // ホスト名ではなく assetBase (実配信プレフィックス) で判定する
    if (tagName !== 'script' && tagName !== 'link') return;
    var assetBase = config.assetBase;
    if (!assetBase || typeof url !== 'string') return;
    // assetBase は protocol-relative (//host/...) のため scheme 付き URL も前方一致で判定
    if (
      url.indexOf(assetBase) !== 0 &&
      url.indexOf('https:' + assetBase) !== 0 &&
      url.indexOf('http:' + assetBase) !== 0
    ) {
      return;
    }
    // 自動化ブラウザ・クローラはアセット取得を中断/遮断するため、実ユーザーに影響しない
    // 読込失敗を大量に生む (ユーザー 0 人の Resource load failed の主因と推定)
    if (isAutomatedClient()) return;
    var cleanUrl = url.split('?')[0];
    if (reportedResources[cleanUrl]) return;
    if (resourceReportCount >= MAX_RESOURCE_REPORTS) return;
    // ページ遷移をまたいだ同一セッション内の重複送信を抑止する
    // (ストレージ不可の環境では従来どおりページビュー単位の制御のみ)
    var sessionKey = 'sentry_res_' + cleanUrl;
    try {
      if (window.sessionStorage.getItem(sessionKey)) return;
      window.sessionStorage.setItem(sessionKey, '1');
    } catch (e) {
      /* ストレージ不可は無視 */
    }
    reportedResources[cleanUrl] = true;
    resourceReportCount++;
    // URL 全体を fingerprint にすると issue が URL ごとに無限分裂するため、
    // 種別 + ファイル名でグルーピングする
    var fileName = cleanUrl.split('/').pop();
    SentrySdk.withScope(function (scope) {
      scope.setTag('resource_error', 'true');
      scope.setFingerprint(['resource-load-failed', tagName, fileName]);
      SentrySdk.captureMessage(
        'Resource load failed: <' + tagName + '> ' + cleanUrl,
        'error'
      );
    });
  }
})();
